import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { Person } from 'src/app/assabil-kernel/models/entities/master-data/person-entity';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { PackingOrderBatch } from './packing-order-batch';
import { PackingOrderProduct } from './packing-order-product';
import { PackingOrderStep } from './packing-order-step';
import { PackingProcess } from './packing-process';



export class PackingOrder extends BaseEntity {

  	id              	: number;
	packingProcess  	: PackingProcess ;
	product         	: Product;
	role            	: Role ;
	person          	: Person ;
	branch          	: Branch;
	packingOrderCode	: string ;
	comment         	: string;
	quantity			: number = 0;
	packingDate			: Date;
	theDate         	: Date;
	expiringDate    	: Date ;
	progressLevel		: number;

	packingOrderSteps	: PackingOrderStep[];
	packingOrderProducts: PackingOrderProduct[];
	packingOrderBatchs	: PackingOrderBatch[];

  constructor() {
    super();

  }
}


	
